
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bA62P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $lsxnT = parcelRequire("lsxnT");


var $jmjWc = parcelRequire("jmjWc");





var $luv00 = parcelRequire("luv00");

/* QuickSummaryButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $3gadb = parcelRequire("3gadb");








var $3DisR = parcelRequire("3DisR");


var $bmowW = parcelRequire("bmowW");

const $3858b10110111223$var$ButtonTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _k48p1wq8 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $3858b10110111223$export$884aa7723c662749 = ({ isOpen: isOpen, setIsOpen: setIsOpen, triggerProps: triggerProps, contentId: contentId, hasSeenSpotlight: hasSeenSpotlight, endSpotlight: endSpotlight, source: source, buttonStyles: buttonStyles, isCurrentUserContributor: isCurrentUserContributor, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const summarizeText = intl.formatMessage((0, $bmowW.i18n).quickSummaryToolTipText);
    const customTheme = (currentTheme, theme)=>{
        const existingTheme = currentTheme(theme);
        const defaultStyles = {
            buttonStyles: {
                ...existingTheme.buttonStyles,
                alignItems: 'center',
                gap: "var(--ds-space-025, 2px)",
                '&:hover': {
                    backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`
                },
                padding: buttonStyles?.padding || `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
                border: buttonStyles?.border || existingTheme.buttonStyles.border,
                borderRadius: buttonStyles?.borderRadius || existingTheme.buttonStyles.borderRadius
            }
        };
        return {
            ...existingTheme,
            ...defaultStyles
        };
    };
    const onButtonClicked = ()=>{
        if (!isOpen) {
            onOpen?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryIconButton',
                    objectId: contentId,
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: !!hasSeenSpotlight,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        isCurrentUserContributor: !!isCurrentUserContributor,
                        popularFeedTimeGranularity: popularFeedTimeGranularity,
                        followingFeedSortby: followingFeedSortby
                    }
                }
            }).fire();
        } else {
            onClose?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'quickSummary',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryCloseIconButton',
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: !!hasSeenSpotlight,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        source: source
                    }
                }
            }).fire();
        }
        setIsOpen(!isOpen);
        endSpotlight?.();
    };
    const renderButton = ()=>{
        const buttonText = buttonStyles?.buttonText ?? summarizeText;
        if (buttonStyles?.standardButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ...triggerProps,
            "aria-haspopup": "dialog",
            testId: "quick-summary-button-new",
            isSelected: isOpen,
            onClick: onButtonClicked,
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3DisR.QuickSummaryIcon), {
                    label: ""
                }),
            "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
        }, buttonText);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            ...triggerProps,
            "aria-haspopup": "dialog" // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            ,
            theme: customTheme,
            spacing: "none",
            testId: "quick-summary-button",
            appearance: "subtle",
            isSelected: isOpen,
            onClick: onButtonClicked,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3DisR.QuickSummaryIcon), {
                label: ""
            }),
            "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3858b10110111223$var$ButtonTextWrapper, null, buttonText));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        position: source === 'page' || source === 'whiteboard' ? 'bottom' : 'top',
        content: summarizeText
    }, renderButton());
};


/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");





var $9oxdN = parcelRequire("9oxdN");

const $6e497b2b7e7b69c0$var$useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery = (0, $eSUdr.default)`query useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery($contentId:ID!){getSmartContentFeature(contentId:$contentId){readTime}contentContributors(id:$contentId){isCurrentUserContributor}}`;
const $6e497b2b7e7b69c0$export$b44dbe53b83fd5c4 = (contentId, source)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const [showFeatureSpotlight, stopFeatureSpotlight, featureSpotlightError] = (0, $9oxdN.useFeatureDiscovery)('quick.summary.ga.feature.spotlight.one');
    const { data: data, error: unifiedQueryError } = (0, $j1Ss3.useQuery)($6e497b2b7e7b69c0$var$useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery, {
        variables: {
            contentId: contentId
        },
        errorPolicy: 'none',
        fetchPolicy: 'network-only'
    });
    const readTime = data?.getSmartContentFeature?.readTime ?? 0;
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor;
    const isEligibleForSpotlight = isAdminHubAIEnabled && showFeatureSpotlight && !featureSpotlightError && source === 'page' && readTime >= 4 && !isCurrentUserContributor;
    const spotlightEligibilityError = featureSpotlightError || unifiedQueryError;
    return {
        isEligibleForSpotlight: isEligibleForSpotlight,
        stopFeatureSpotlight: stopFeatureSpotlight,
        spotlightEligibilityError: spotlightEligibilityError,
        isCurrentUserContributor: isCurrentUserContributor
    };
};


const $462df38526e18a79$export$81dd2a56460c8cd9 = ({ isOpen: isOpen, setIsOpen: setIsOpen, triggerProps: triggerProps, contentId: contentId, source: source, buttonStyles: buttonStyles, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $6e497b2b7e7b69c0$export$b44dbe53b83fd5c4)(contentId, source);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "quick-summary-popup",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3858b10110111223$export$884aa7723c662749), {
        contentId: contentId,
        triggerProps: triggerProps,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        source: source,
        buttonStyles: buttonStyles,
        onOpen: onOpen,
        onClose: onClose,
        isCurrentUserContributor: isCurrentUserContributor,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }));
};



var $NomII = parcelRequire("NomII");








var $dPJCf = parcelRequire("dPJCf");




const $ff45dc1c950c6fe5$var$useOpenQuickSummaryParam = (0, $dPJCf.createSingleQueryParamHook)('openQuickSummary');
const $ff45dc1c950c6fe5$export$1e7c1e0a8136f3b6 = (isOpen, source, setIsOpen, contentId)=>{
    const [hasSeen, setHasSeen] = (0, $42omo.useState)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOpenQuickSummaryQueryParamValid = $ff45dc1c950c6fe5$var$useOpenQuickSummaryParam() === 'true';
    (0, $42omo.useEffect)(()=>{
        if (!isOpen && source === 'page' && isOpenQuickSummaryQueryParamValid && !hasSeen) {
            setIsOpen(true);
            setHasSeen(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryIconButton',
                    objectId: contentId,
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: false,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        isFromQueryParam: true
                    }
                }
            }).fire();
        }
    }, [
        isOpen,
        setIsOpen,
        isOpenQuickSummaryQueryParamValid,
        hasSeen,
        setHasSeen,
        source,
        contentId,
        createAnalyticsEvent,
        edition,
        isAdminHubAIEnabled
    ]);
};



const $d0b8c8c6e36f04fe$var$QuickSummaryPopupContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-ztCJ",
    name: "QuickSummaryPopupContent",
    loader: async ()=>(await (parcelRequire("7uUed"))).QuickSummaryPopupContent
});
const $d0b8c8c6e36f04fe$export$e82b88b8e9b29fb6 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, lastModifiedDate: lastModifiedDate = '', source: source, contentPath: contentPath, setIsFeedMenuOpen: setIsFeedMenuOpen, buttonStyles: buttonStyles, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    (0, $ff45dc1c950c6fe5$export$1e7c1e0a8136f3b6)(isOpen, source, setIsOpen, contentId);
    const popupOffset = !isAdminHubAIEnabled ? [
        -10,
        8
    ] : [
        -34,
        8
    ];
    (0, $42omo.useEffect)(()=>{
        if (setIsFeedMenuOpen) setIsFeedMenuOpen(!!isOpen);
    }, [
        setIsFeedMenuOpen,
        isOpen
    ]);
    const onPopupClose = ()=>{
        setIsOpen(false);
        onClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'quickSummary',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummaryCloseOut',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    source: source
                }
            }
        }).fire();
    };
    if (contentType === 'page' || contentType === 'blogpost' || contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        isOpen: isOpen,
        onClose: onPopupClose,
        placement: "bottom",
        offset: popupOffset,
        content: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d0b8c8c6e36f04fe$var$QuickSummaryPopupContent, {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                lastModifiedDate: lastModifiedDate,
                source: source,
                contentPath: contentPath,
                setIsOpen: setIsOpen,
                onUpdate: props.update
            }),
        popupComponent: (0, $NomII.CustomPopupContainer),
        shouldFlip: false,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $462df38526e18a79$export$81dd2a56460c8cd9), {
                contentId: contentId,
                triggerProps: triggerProps,
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                source: source,
                buttonStyles: buttonStyles,
                onOpen: onOpen,
                onClose: onClose,
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            })
    }));
    return null;
};
module.exports["QuickSummaryPopup"] = $d0b8c8c6e36f04fe$export$e82b88b8e9b29fb6;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("9oxdN", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iyPd9 = parcelRequire("iyPd9");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $eSUdr.default)`query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $eSUdr.default)`mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey pluginKey:$pluginKey){pluginKey featureKey}}`;
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (cache, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    const cachedFeatureData = cache.readQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery)
    });
    if (newMarkedFeature && cachedFeatureData?.featureDiscovery) cache.writeQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery),
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $xQxzY.useQuery)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $1KmJq.useMutation)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("iyPd9", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b4e2a77d9a5ab99b$export$b3c271f2152800f6 = (0, $eSUdr.default)`query FeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
module.exports["FeatureDiscoveryQuery"] = $b4e2a77d9a5ab99b$export$b3c271f2152800f6;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eyWa4 = parcelRequire("eyWa4");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _16qs130s _1pbykb7n _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("7uUed", function(module, exports) {

let $5756f385f539cc12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5756f385f539cc12$var$load("fqXA9"),
    $5756f385f539cc12$var$load("ipoo6"),
    $5756f385f539cc12$var$load("iK6Gk"),
    $5756f385f539cc12$var$load("fD0v8"),
    $5756f385f539cc12$var$load("6XCf4"),
    $5756f385f539cc12$var$load("5pvpJ"),
    $5756f385f539cc12$var$load("hhss7"),
    $5756f385f539cc12$var$load("1qlDN"),
    $5756f385f539cc12$var$load("1yVM6"),
    $5756f385f539cc12$var$load("jxz2q"),
    $5756f385f539cc12$var$load("hcY7w"),
    $5756f385f539cc12$var$load("1Jgsw"),
    $5756f385f539cc12$var$load("h2QhJ"),
    $5756f385f539cc12$var$load("1iUSs"),
    $5756f385f539cc12$var$load("7EorR"),
    $5756f385f539cc12$var$load("St9Nk"),
    $5756f385f539cc12$var$load("9ijrN"),
    $5756f385f539cc12$var$load("f1NVy"),
    $5756f385f539cc12$var$load("6wr18"),
    $5756f385f539cc12$var$load("736as"),
    $5756f385f539cc12$var$load("kUbT8"),
    $5756f385f539cc12$var$load("jrchu"),
    $5756f385f539cc12$var$load("ffEVr"),
    $5756f385f539cc12$var$load("3eopS")
]).then(()=>parcelRequire('alkm2'));

});


//# sourceMappingURL=QuickSummaryPopup.c5804470.js.map
